module.exports = __webpack_public_path__ + "static/why-content-image-5-fb7ab1384792e9c7487e7fcd6605362a.svg";